// import { refreshAccessToken } from '@/plugins/axios'
import store from '@/store'

async function refreshUserinfo () {
    store.dispatch('auth/refreshAccessToken')
}

async function getAvailableResources () {
    return this.api({
        url: `/auth/resources`,
        method: 'GET'
    })
}

async function login ( options ) {
    return this.api({
        url: `/auth/login`,
        method: 'POST',
        data: {
            email: options.email,
            password: options.password
        }
    })
}

async function resetPassword (email) {
    return this.api({
        url: `/auth/password`,
        method: 'DELETE',
        data: {
            email: email
        }
    })
}

async function changePassword (options) {
    return this.api({
        url: `/auth/password`,
        method: 'POST',
        data: {
            password: options.password,
            confirm_password: options.confirm_password
        }
    })
}

async function setPassword (hash, options) {
    return this.api({
        url: `/auth/password/${hash}`,
        method: 'POST',
        data: {
            password: options.password,
            confirm_password: options.confirmPassword
        }
    })
}

export default {
    pluginName: 'auth',
    methods: {
        getAvailableResources,
        login, refreshUserinfo,
        resetPassword, changePassword, setPassword
    }
}